import React, { useState } from "react";
import { useAppContext } from "../../context/appContext";
import { Input, Checkbox, Select } from "../workspace";
import ConfirmBox from "../ConfirmBox";

const AdminUsers = () => {
  const {
    isLoading,
    createRecord,
    saveRecord,
    employees,
    lists,
    displayAlert,
    handleArrayChanges,
    showConfirmBox,
    toggleConfirmBox,
  } = useAppContext();

  const [selectedRow, setSelectedRow] = useState(null);
  const [index, setIndex] = useState(0);
  const [newPassword, setNewPassword] = useState("");

  const defaultPassword = process.env.REACT_APP_DEFAULT_PASSWORD;

  const handleInput = (e) => {
    const property = e.target.name;
    const value = property === "user_roles_id" ? Number(e.target.value) : e.target.value;
    const baseArray = [...employees];
    const baseName = "employees";
    handleArrayChanges({
      baseName,
      baseArray,
      index,
      newValues: { [property]: value },
    });
  };
  const changeColor = (id) => {
    const baseArray = [...employees];
    const baseName = "employees";
    handleArrayChanges({
      baseName,
      baseArray,
      index,
      newValues: { color: id },
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Make sure required fields are present
    if (
      !employees[index]?.full_name ||
      !employees[index]?.nickname ||
      !employees[index]?.user_roles_id
    ) {
      displayAlert("Please include full name, user name, and user role");
      return;
    }
    // Check employees and create/update
    if (!employees[index]?.id) {
      // Create new employee
      const record = await createRecord("/auth/register", employees[index], "option");
      // Give the new user the default password
      console.log("defaultPassword:", defaultPassword);
      await saveRecord(
        `/auth/update-password/${record.id}`,
        { newPassword: defaultPassword },
        "Password"
      );
      // Update state with saved employee data
      handleArrayChanges({
        baseName: "employees",
        baseArray: [...employees],
        index,
        newValues: { id: record.id },
      });
    } else {
      saveRecord(`/auth/update-user/${employees[index].id}`, employees[index], "employee");
    }

    console.log("update records");
  };
  const selectTblRow = async (e, employeeId, row) => {
    setIndex(row);
    setSelectedRow(employeeId);
  };
  const handleCheckBox = ({ property, value }) => {
    const baseName = "employees";
    const baseArray = [...employees];
    handleArrayChanges({
      baseName,
      baseArray,
      index,
      newValues: { [property]: value },
    });
  };
  const newEmployee = async (e) => {
    e.preventDefault();

    handleArrayChanges({
      baseName: "employees",
      baseArray: [...employees],
      index: employees.length || 0,
      newValues: { admin: false, service_rep: false, active: true },
    });
    setIndex(employees.length || 0);
  };

  const updatePassword = () => {
    console.log("hold on to your butts, we're updating this password...");
    saveRecord(`/auth/update-password/${employees[index]?.id}`, { newPassword }, "Password");
  };
  const toggleSetPassword = (e) => {
    e.preventDefault();
    if (newPassword.length < 8) {
      displayAlert("Please use at least 8 characters in the password");
      return;
    } else if (newPassword.search(/\d/) < 0) {
      displayAlert("Please include at least one number");
      return;
    } else if (newPassword.search(/[A-Z]/) < 0) {
      displayAlert("Please include at least one capital letter");
      return;
    }
    toggleConfirmBox({ confirmed: false });
  };
  const lastAppt = employees[employees?.length - 1];

  const EmployeeTable = ({ employeeList }) => {
    return (
      <div className="form-row whole">
        <div className="employees">
          <table>
            <tbody>
              <tr>
                <th style={{ width: 120 }}>Name</th>
                <th style={{ width: 120 }}>Title</th>
                <th style={{ width: 120 }}>Email</th>
                <th style={{ width: 70 }}>JMS User Role</th>
              </tr>
              {employees?.map((employee, index) => {
                const { full_name, title, email, user_roles_id } = employee;
                const userRole =
                  user_roles_id &&
                  lists.listUserRoles.find((role) => {
                    return role.id === user_roles_id;
                  })?.text;
                if (employeeList.includes(employee)) {
                  return (
                    <tr
                      key={employee.id || 0}
                      className={selectedRow === employee.id ? "selected" : ""}
                      onClick={(e) => selectTblRow(e, employee.id, index)}
                    >
                      <td>{full_name}</td>
                      <td>{title}</td>
                      <td>{email}</td>
                      <td>{userRole || "N/A"}</td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  const activeEmployees = employees.filter((emp) => emp.user_roles_id !== 100);
  const inactiveEmployees = employees.filter((emp) => emp.user_roles_id === 100);

  return (
    <div className="page">
      {/* ----- Active Employees ------ */}
      <div className="group whole">
        <form onSubmit={handleSubmit} className="form">
          <h3>Active Employees</h3>
          <div className="form-center">
            <EmployeeTable employeeList={activeEmployees} />

            <div className="btn-block">
              {employees?.length > 0 && !lastAppt?.id ? (
                ""
              ) : (
                <button
                  className="btn"
                  type="button"
                  onClick={(e) => newEmployee(e)}
                  disabled={isLoading}
                >
                  {isLoading ? "please wait..." : "New Employee"}
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
      {/* ----- Employee Details ------ */}
      <div className="group whole">
        <form onSubmit={handleSubmit} className="form">
          <h3>Employee Details</h3>
          <div className="form-center">
            {employees[index] ? (
              <div className="whole flex-parent">
                {/* Left Column */}
                <div className="one-half flex-parent">
                  <div className="whole flex-parent">
                    <div className="one-half">
                      <Input
                        type="text"
                        name="full_name"
                        labelText="Full Name"
                        value={employees[index]?.full_name || ""}
                        handleChange={(e) => handleInput(e)}
                      />
                    </div>
                    <div className="one-half">
                      <Input
                        type="text"
                        name="nickname"
                        labelText="User Name"
                        value={employees[index]?.nickname || ""}
                        handleChange={(e) => handleInput(e)}
                      />
                    </div>
                  </div>
                  <div className="whole">
                    <Input
                      type="text"
                      name="title"
                      labelText="title"
                      value={employees[index]?.title || ""}
                      handleChange={(e) => handleInput(e)}
                    />
                  </div>
                  <div className="whole">
                    <Input
                      type="text"
                      name="email"
                      labelText="email"
                      value={employees[index]?.email || ""}
                      handleChange={(e) => handleInput(e)}
                    />
                  </div>
                </div>
                {/* Right Column */}
                <div className="one-half flex-parent">
                  {/* User Role */}
                  <div className="whole">
                    <Select
                      name="user_roles_id"
                      labelText="User Role"
                      value={employees[index]?.user_roles_id}
                      handleChange={(e) => handleInput(e)}
                      options={lists && lists.listUserRoles.filter((role) => role.id > 0)}
                    />
                  </div>
                  {/* is service rep */}
                  <div
                    className={
                      employees[index]?.service_rep
                        ? "whole checked checkbox outline-box"
                        : "whole checkbox outline-box"
                    }
                    onClick={() =>
                      handleCheckBox({
                        property: "service_rep",
                        value: !employees[index]?.service_rep,
                      })
                    }
                  >
                    <Checkbox
                      type="checkbox"
                      name="service_rep"
                      labelText="Service Rep"
                      checked={employees[index]?.service_rep || false}
                      handleChange={() => {}}
                    />
                  </div>

                  {/* Color */}
                  <div className="one-half">
                    <ColorPicker
                      value={employees[index]?.color}
                      onChange={(id) => changeColor(id)}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="whole flex-parent">
                <h3>Please select an employee...</h3>
              </div>
            )}
            <div className="button-group whole flex-parent">
              <div className="btn-block">
                <button className="btn" type="submit" disabled={isLoading}>
                  {isLoading
                    ? "please wait..."
                    : employees[index]?.id
                    ? "Save User"
                    : "Create New User"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      {/* ----- Security Settings ------ */}
      <div className="group whole">
        <form onSubmit={handleSubmit} className="form">
          <h3>Security Settings</h3>
          <div className="form-center">
            {/* Password */}
            <div className="whole flex-parent">
              <div className="three-fourths">
                <Input
                  type="text"
                  name="full_name"
                  labelText="Password"
                  value={newPassword || ""}
                  handleChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
              <div className="one-fourth flex-parent">
                <button className="btn btn-block" onClick={toggleSetPassword} disabled={isLoading}>
                  {isLoading ? "please wait..." : "Change Password"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      {/* ----- Inactive Employees ------ */}
      <div className="group whole">
        <form onSubmit={handleSubmit} className="form">
          <h3>Inactive Employees</h3>
          <div className="form-center">
            <EmployeeTable employeeList={inactiveEmployees} />
          </div>
        </form>
      </div>
      {/* ----- Confirmation Box ------ */}
      <div className={showConfirmBox ? "show-modal modal-container" : "modal-container"}>
        <div className="group">
          <ConfirmBox
            confirmedFunction={updatePassword}
            message={`Are you sure you want to change the password for ${employees[index]?.nickname}?`}
          />
        </div>
      </div>
    </div>
  );
};
export default AdminUsers;

const GOOGLE_COLORS = [
  { id: "1", name: "Lavender", background: "#7986cb", foreground: "#1d1d1d" },
  { id: "2", name: "Sage", background: "#33b679", foreground: "#1d1d1d" },
  { id: "3", name: "Grape", background: "#8e24aa", foreground: "#1d1d1d" },
  { id: "4", name: "Flamingo", background: "#e67c73", foreground: "#1d1d1d" },
  { id: "5", name: "Banana", background: "#f6bf26", foreground: "#1d1d1d" },
  { id: "6", name: "Tangerine", background: "#f4511e", foreground: "#1d1d1d" },
  { id: "7", name: "Peacock", background: "#039be5", foreground: "#1d1d1d" },
  { id: "8", name: "Graphite", background: "#616161", foreground: "#ffffff" },
  { id: "9", name: "Blueberry", background: "#3f51b5", foreground: "#ffffff" },
  { id: "10", name: "Basil", background: "#0b8043", foreground: "#ffffff" },
  { id: "11", name: "Tomato", background: "#d50000", foreground: "#ffffff" },
];

function ColorPicker({ value = "9", onChange }) {
  console.log("colorPicker value:", value)
  console.log("colorPicker typeof value:", typeof value)

  const selected = GOOGLE_COLORS.find((c) => c.id === value) ?? GOOGLE_COLORS[8];

  function handleSelect(id) {
    onChange(id);
  }

  return (
    <div className="color-picker">
      <label className="color-picker__label">Calendar color</label>
      <div className="color-picker__swatches">
        {GOOGLE_COLORS.map((c) => (
          <button
            key={c.id}
            type="button"
            title={c.name}
            onClick={() => handleSelect(c.id)}
            className={`color-picker__swatch${
              c.id === value ? " color-picker__swatch--selected" : ""
            }`}
            style={{ backgroundColor: c.background }}
          />
        ))}
      </div>
      <div className="color-picker__caption">
        {selected.name} · value {selected.id}
      </div>
    </div>
  );
}
